// document is ready when run code
import { createSlider } from "../../Helpers/tools";

document.addEventListener("DOMContentLoaded", function() {
  createSlider({
    selector: ".js-three-columns-slider",
    slidesPerView: "auto",
    spaceBetweenInMobile: 16,
    spaceBetweenInDesktop: 36,
  });

  createSlider({
    selector: ".js-two-columns-slider",
    slidesPerView: 2,
    spaceBetweenInMobile: 0,
    spaceBetweenInDesktop: 24,
    pagination: ".js-two-columns-slider-pagination",
    customOptions: {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    }
  });

  // js-best-package-select
  Array.from(document.querySelectorAll(".js-best-package-select")).forEach(
    (item) => {
      item.addEventListener("change", (event) => {
        let target = event.target;

        target
          .closest(".js-best-package")
          .querySelector(".js-best-package-items.active")
          .classList.remove("active");

        document.getElementById(target.value).classList.add("active");
      });
    }
  );
});
